import { useQuery } from "@tanstack/react-query";
import { CACHE_TIME, STALE_TIME } from "../ApiProvider";
import { api } from "./api";
const USE_LIST_AGGREGATED_STATS_BY_TEAM = "useListAggregatedStatsByTeam";
export const useListAggregatedPlayerStatsByTeam = ({ teamId, enabled = true, }) => {
    return useQuery({
        queryKey: [USE_LIST_AGGREGATED_STATS_BY_TEAM, teamId],
        queryFn: async () => {
            const response = await api.get(`/teams/${teamId}/aggregated-player-stats/`);
            return response.data;
        },
        enabled: !!teamId && enabled,
        staleTime: STALE_TIME, // 30 seconds
        cacheTime: CACHE_TIME, // 5 minutes
    });
};
